<template>
  <v-combobox
    v-if="suggestions && suggestionsSource === 'persistence'"
    :name="schema.fullkey"
    :label="label || schema.label"
    :readonly="readonly || schema.readonly || loading"
    :loading="loading"
    :disabled="disabled || schema.disabled"
    :value="inputValue"
    :items="suggestionsData"
    :class="refSpecs != null ? 'mt-0 pt-0' : null"
    @input="emitInput($event)"
  >
    <v-tooltip
      v-if="schema.description && schema.description.length > 0"
      slot="append-outer"
      color="white grey--text"
      left
    >
      <v-icon
        slot="activator"
        style="font-size: 22px;color:white; border-radius:20px"
        class="grey"
        dark
        >info</v-icon
      >
      <div class="vjsf-tooltip" v-html="schema.description" />
    </v-tooltip>

    <!-- begin ref buttons -->
    <v-tooltip
      v-if="refSpecs != null"
      :slot="
        refSpecs.selectBtn != null && refSpecs.selectBtn.placement != null
          ? refSpecs.selectBtn.placement
          : 'append'
      "
      color="white grey--text"
      left
    >
      <v-btn slot="activator" icon class="ma-0" @click="$emit('refShowList')">
        <v-icon>find_replace</v-icon>
      </v-btn>
      <div class="vjsf-tooltip">
        {{
          refSpecs.selectBtn != null && refSpecs.selectBtn.description != null
            ? refSpecs.selectBtn.description
            : 'Select'
        }}
      </div>
    </v-tooltip>
    <v-tooltip
      v-if="refSpecs != null"
      :slot="
        refSpecs.clearBtn != null && refSpecs.clearBtn.placement != null
          ? refSpecs.clearBtn.placement
          : 'append'
      "
      color="white grey--text"
      left
    >
      <v-btn
        slot="activator"
        icon
        class="ma-0"
        @click="$emit('refClearSelection')"
      >
        <v-icon>clear</v-icon>
      </v-btn>
      <div class="vjsf-tooltip">
        {{
          refSpecs.clearBtn != null && refSpecs.clearBtn.description != null
            ? refSpecs.clearBtn.description
            : 'Clear'
        }}
      </div>
    </v-tooltip>
    <!-- end ref buttons -->
  </v-combobox>
  <v-text-field
    v-else
    :value="inputValue"
    :name="schema.fullkey"
    :label="label || schema.label"
    :readonly="readonly || schema.readonly"
    :disabled="disabled || schema.disabled"
    :rules="rules()"
    min-width="290px"
    :class="refSpecs != null ? 'mt-0 pt-0' : null"
    @input="emitInput($event)"
  >
    <v-tooltip
      v-if="schema.description && schema.description.length > 0"
      slot="append"
      color="white grey--text"
      left
    >
      <v-icon
        slot="activator"
        style="font-size: 22px;color:white; border-radius:20px"
        class="grey"
        dark
        >info</v-icon
      >
      <div class="vjsf-tooltip" v-html="schema.description" />
    </v-tooltip>
    <!-- begin ref buttons -->
    <v-tooltip
      v-if="refSpecs != null"
      :slot="
        refSpecs.selectBtn != null && refSpecs.selectBtn.placement != null
          ? refSpecs.selectBtn.placement
          : 'append'
      "
      color="white grey--text"
      left
    >
      <v-btn slot="activator" icon class="ma-0" @click="$emit('refShowList')">
        <v-icon>filter_list</v-icon>
      </v-btn>
      <div class="vjsf-tooltip">
        {{
          refSpecs.selectBtn != null && refSpecs.selectBtn.description != null
            ? refSpecs.selectBtn.description
            : 'Select'
        }}
      </div>
    </v-tooltip>
    <v-tooltip
      v-if="refSpecs != null"
      :slot="
        refSpecs.clearBtn != null && refSpecs.clearBtn.placement != null
          ? refSpecs.clearBtn.placement
          : 'append'
      "
      color="white grey--text"
      left
    >
      <v-btn
        slot="activator"
        icon
        class="ma-0"
        @click="$emit('refClearSelection')"
      >
        <v-icon class="icon">delete_outlined</v-icon>
      </v-btn>
      <div class="vjsf-tooltip">
        {{
          refSpecs.clearBtn != null && refSpecs.clearBtn.description != null
            ? refSpecs.clearBtn.description
            : 'Clear'
        }}
      </div>
    </v-tooltip>
    <!-- end ref buttons -->
  </v-text-field>
</template>

<script>
import ApiService from '../APIService'
import { Utils } from '../Utils'
let utils = new Utils()
export default {
  name: 'RDTextWidget',
  // components: {
  //   RefSelectEntryBtn: () => import('../others/RefSelectEntryBtn.vue')
  // },
  props: {
    schema: {
      type: Object,
      required: true
    },
    initialValue: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    suggestions: {
      type: Boolean,
      default: false
    },
    // The suggestions will be fetched from the backend and will be based on distinct values for this field
    suggestionsSource: {
      type: String,
      default: 'persistence'
    },
    // Used for api calls
    entityId: {
      type: String,
      default: null
    },
    widgetKey: {
      type: String,
      default: null
    },
    refSpecs: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      inputValue: this.value || null,
      suggestionsData: [],
      loading: false
    }
  },
  created() {
    if (this.schema.defaultValue != undefined) {
      this.$emit('inputChange', this.schema.defaultValue)
    }
    this.refreshSuggestionsData()
  },
  methods: {
    emitInput: function(value) {
      if (this.schema.transmit !== undefined)
        this.$emit('transmit', this.schema.transmit, value)
      this.$emit('input', value)
    },
    refreshSuggestionsData: function() {
      if (!this.suggestions) return
      this.loading = true
      ApiService.getFieldSuggestions(this.entityId, this.widgetKey)
        .then((response) => {
          this.suggestionsData = response.data
          this.loading = false
        })
        .catch(() => {
          console.log('Error fetching text field suggestions: ')
          this.suggestionsData = []
          this.loading = false
        })
    },
    rules: function() {
      if (this.schema.rules === undefined || this.schema.rules === null) return
      var rules = []
      if (this.schema.rules.type === 'email')
        rules = rules.concat(utils.getEmailRules())
      if (this.schema.rules.type === 'phone')
        rules = rules.concat(utils.getPhoneRules())
      if (this.schema.rules.type === 'number')
        rules = rules.concat(utils.getNumberRules())
      if (this.schema.rules.type === 'decimal-number')
        rules = rules.concat(utils.getDecimalNumberRules())
      if (this.schema.rules.type === 'name')
        rules = rules.concat(utils.getNameRules())
      if (this.schema.rules.type === 'cnp') {
        if (this.value !== null) {
          rules = rules.concat(utils.getCnpRules())
        }
      }
      if (this.schema.rules.type === 'serie')
        rules = rules.concat(utils.getSerieRules())
      if (this.schema.rules.type === 'idnumber')
        rules = rules.concat(utils.getIdNumberRules())
      if (this.schema.rules.type === 'bankaccount')
        rules = rules.concat(utils.getCardNumberRules())
      if (this.schema.rules.type === 'cui')
        rules = rules.concat(utils.getCuiRules())
      if (this.schema.rules.type === 'caen')
        rules = rules.concat(utils.getCaenRules())
      if (this.schema.rules.type === 'projectid')
        rules = rules.concat(utils.getProjectIdRules())
      if (this.schema.rules.type === 'fax')
        rules = rules.concat(utils.getFaxRules())
      if (this.schema.rules.required === true)
        rules = rules.concat(utils.getRequiredRules())
      if (this.schema.rules.minLength !== undefined)
        rules = rules.concat(utils.getBiggerRules(this.schema.rules.minLength))
      if (this.schema.rules.maxLength !== undefined)
        rules = rules.concat(utils.getLessRules(this.schema.rules.maxLength))
      return rules
    }
  }
}
</script>

<style>
.icon {
  margin-left: 23px;
}
</style>
